import * as React from 'react';

export function Button(props) {
  const {clickHandler, disabled, text} = props;
  return (
    <button
      className='nv-cta-primary nv-cta-primary--small'
      disabled={disabled}
      onClick={clickHandler}>
      {text}
    </button>
  );
}

export function SkipButton(props) {
  const {clickHandler, disabled, text} = props;
  return (
    <button
      className='nv-cta-primary nv-cta-primary--small nv-cta-primary--skip'
      disabled={disabled}
      onClick={clickHandler}>
      {text}
    </button>
  );
}
